/**
 * Calls to the test-prep-iii (TP3) teacher standards endpoints (TP-1321, DH-361).
 *
 * TP3 is mounted on the same origin at /internal/tp3/ and authenticates with the same
 * monolith session cookie as this page, so no token handling is needed. The endpoints
 * answer 403 for anyone who is not a teacher or administrator.
 */
const tp3AjaxPath = '/internal/tp3/Ajax/Ajax.php';

/**
 * Builds a TP3 Ajax url, dropping empty params and encoding the rest
 *
 * @param action
 * @param params
 * @returns {string}
 */
export const buildTp3Url = (action, params = {}) => {
	const query = Object.keys(params)
		.filter(key => params[key] !== null && typeof params[key] !== 'undefined' && params[key] !== '')
		.map(key => '&' + key + '=' + encodeURIComponent(params[key]))
		.join('');

	return tp3AjaxPath + '?action=' + action + query;
};

/**
 * GETs a TP3 action and resolves with its payload. Rejects with an object shaped like a
 * fetch Response ({status, statusText}) so ResponseErrorMessage can show it.
 *
 * @param action
 * @param params
 * @param signal - AbortController signal
 * @returns {Promise<object>}
 */
export const fetchTp3 = async(action, params, signal) => {
	const response = await fetch(buildTp3Url(action, params), {
		credentials: 'same-origin',
		signal: signal
	});

	if (!response.ok) {
		throw { status: response.status, statusText: response.statusText };
	}

	const json = await response.json();

	return json.payload;
};

export const kindGroups = [
	{ kind: 'drill', title: 'Drills' },
	{ kind: 'practice', title: 'Practice tests' },
	{ kind: 'diagnostic', title: 'Diagnostics' },
	{ kind: 'reading', title: 'Readings' }
];

/**
 * The short handle for a standard: its code, else a short outline label
 *
 * @param standard
 * @returns {string}
 */
export const standardHandle = standard => {
	if (standard.code) {
		return standard.code;
	}

	return standard.label && standard.label.length <= 12 ? standard.label : '';
};
